import React from 'react'
import districtList from '../assets/districtList'
import Toggle from './Toggle'

import '../App.css'
import '../styles/mapkey.scss'
import '../styles/index.scss'
import '../styles/toggle.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


//create a map that cycles through and generates buttons
export default function MapKey(props){

    const toggleDistList = districtList.map(item=> {
        return (
            <Toggle
                key={item.id} 
                id={item.id}
                onClick={props.onClick}
                label={item.id}
                color={item.color}
                link="true"
                url={item.link}
            />  
        )
    })

    return(
        <div className="key-component">
        <div className="mapkey-btn">

            <div className="card-header">
                <div className="header-front">
                    <FontAwesomeIcon icon={['far', 'map']} size="2x" className="font-awesome-spacing"/>

                    <h2 className="text-header">Map</h2>
                </div>

            </div>

            <h3 className="key-heading">Style</h3>
            
            <div className="mobile-group">
            <Toggle 
                id="satellite"
                onClick={props.onClick}
                label="Satellite"
                link="false"
            />
            <Toggle 
                id="terrain-data"
                onClick={props.onClick}
                label="Topography"
                link="false"
            />
            <Toggle 
                id="transit-label"
                onClick={props.onClick}
                label="Subway"
            />
            <Toggle 
                id="road-label-simple"
                onClick={props.onClick}
                label="Labels"
            />
            <Toggle 
                id="landuse"
                onClick={props.onClick}
                label="Parks & Land Use"
                link="false"
            />
            </div>


            <div className="key">
                <h3 className="key-heading">Zoning Districts</h3>
                <a className="hyperlink"
                    href="https://www1.nyc.gov/site/planning/zoning/districts-tools.page"
                    rel="noreferrer noopener"
                    target="_blank">
                    info
                </a>
            </div>

            <div className="zonedist-container">{toggleDistList}</div>
        
        </div>
        </div>
    )
}